export const validateData = (data, schema) => {
  const { error } = schema.validate(data, { abortEarly: false });
  if (error) {
    return error;
  }
  return null;
};
